import { resendConfirmationEmail } from '../providers/user'
import {
  TRANSIENT_MESSAGE_EMAIL_WAS_SENT,
  TRANSIENT_MESSAGE_EMAIL_FAILED_TITLE,
  TRANSIENT_MESSAGE_EMAIL_FAILED_BODY,
} from '../statics'

export default (email, notifications) =>
  resendConfirmationEmail(null, email)
    .then(_ => {
      notifications.overlayBanner.open({
        elmId: 'confirmation-sent-message',
        title: TRANSIENT_MESSAGE_EMAIL_WAS_SENT,
      })
    })
    .catch(_ => {
      notifications.overlayBanner.open({
        title: TRANSIENT_MESSAGE_EMAIL_FAILED_TITLE,
        message: TRANSIENT_MESSAGE_EMAIL_FAILED_BODY,
      })
    })
